module.exports = __webpack_public_path__ + "static/media/landingpage_shutterstock_1187511808-blur.fb5c483d.jpg";